// Client V2 common imports
const articleActions = require('client-v2/common/models/article/actions')
const collectionActions = require('client-v2/common/models/collection/actions')
const interestActions = require('client-v2/common/models/interest/actions')
const userActions = require('client-v2/common/models/user/actions')
// Container imports
const { defaultFeedActions } = require('./actions')
const { FeedStreamRecord } = require('./records')

module.exports = {
  createFeedReducer,
  // If you use the defaultReducer, you MUST also be using the default actions and record type
  defaultFeedReducer: createFeedReducer(defaultFeedActions, FeedStreamRecord)
}

// If you use a custom feedRecord type, make sure it quacks like the same duck.
function createFeedReducer(feedActions, feedRecordType) {
  // eslint-disable-next-line complexity
  return function feedReducer(state = new feedRecordType(), action) {
    const { type, payload } = action
    switch (type) {
      // Feed actions
      case feedActions.MORE_LOADING:
        return state.setNextPageLoading()
      case feedActions.MORE_LOADED:
        return state.appendNextPage(payload)
      case feedActions.PREPEND_ARTICLE:
          return state.prependArticle(payload.article)
      case feedActions.REMOVE_ARTICLE:
        return state.removeArticle(payload.article)
      case feedActions.DEDUPE_SIMILAR_ARTICLES:
        return state.dedupeSimilarArticles()
      // Article model actions
      case articleActions.ARTICLE_DOMAIN_BLOCKED:
        return state.removeArticlesByHostname(payload.hostname)
      case articleActions.ARTICLES_REPORTED:
        return state.removeArticlesByUrlIds(payload.urlIds)
      case articleActions.ARTICLE_RATED:
        return state.meta.matchesPageContext(payload.pageContext)
        ? state.itemsReducer(action)
        : state
      // Whitelist the actions that get passed to the items for performance reasons
      case articleActions.ARTICLE_ADDED_TO_COLLECTION:
      case articleActions.ARTICLE_IS_MIXED_CHANGE_PENDING:
      case articleActions.ARTICLE_REMOVED_FROM_COLLECTION:
      case articleActions.ARTICLE_UPDATED:
      case collectionActions.COLLECTION_FOLLOWING_CHANGE:
      case interestActions.INTEREST_FOLLOWING_CHANGE:
      case userActions.USER_ADJUST_FOLLOWER_COUNT:
      case userActions.USER_FOLLOWING_CHANGE:
        return state.itemsReducer(action)
      default:
        return state
    }
  }
}
